import { useState, useEffect } from 'react';
import axios from 'axios';
import { useKeycloak } from "@react-keycloak/web";

const useAxios = (method, endpoint, payload, stopFirst) => {
    const { keycloak } = useKeycloak();

    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [loaded, setLoaded] = useState(false);
    const [reqStatus, setReqStatus] = useState(0);

    const invokeService = async (method, endpoint, payload) => {
        (async () => {
            setLoaded(false);
            setError("");
            try {
                const response = await axios({
                    method: method,
                    url: process.env.REACT_APP_URL_API + endpoint,
                    data: payload,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + keycloak.token,
                    }
                });


                setReqStatus(response.status);
                setData(response.data);
            } catch (error) {
                if (error.response.status === 401) {
                    keycloak.logout()
                }

                setReqStatus(error.response.status);
                setError(error.message);
            } finally {
                setLoaded(true);
            }
        })();
    };

    useEffect(() => {
        if (!stopFirst)
            invokeService(method, endpoint, payload, stopFirst);
    }, []);

    return { fetch: (newMethod, newEndpoint, newPayload) => invokeService(newMethod, newEndpoint, newPayload), data, error, loaded, reqStatus };
};

export default useAxios;
